import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Position', prop: 'position' },
  { title: 'Webinar', prop: 'webinar_id', references: 'admin/webinars', referenceProp: 'long_title' }
]

const filters = []

const defaults = {
  order: [{ column: 'position', direction: 'asc' }]
}

const CoreCurriculumWebinars = props => (
  <List
    title='Core Curiculum'
    apiPath='admin/core_curriculum_webinars'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default CoreCurriculumWebinars
